<template>
  <div
    id="portletStats"
    class="m-portlet m-portlet--rounded m-portlet--tabs m-portlet--grayed m-portlet--head-solid-bg m-portlet--unair m-portlet--head-xs"
  >
    <div class="px-2 m-portlet__head">
      <div
        v-if="stats"
        class="m-portlet__head-title"
      >
        <small>{{ stats.from.format("DD/MM/YYYY") }} -
          {{ stats.to.format("DD/MM/YYYY") }}</small>
      </div>

      <div class="m-portlet__head-tools">
        <ul
          class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--right m-tabs-line-danger row"
          role="tablist"
        >
          <li class="nav-item m-tabs__item">
            <a
              :class="{
                'cursor-pointer nav-link m-tabs__link': true,
                active: selectedRange === 'sAgo',
              }"
              data-toggle="tab"
              href="?stats=sAgo"
              role="tab"
              @click.prevent="setRange('sAgo')"
            >
              {{ $t("common.days", { count: 7 }) }}
            </a>
          </li>
          <li class="nav-item m-tabs__item">
            <a
              :class="{
                'cursor-pointer nav-link m-tabs__link': true,
                active: selectedRange === 'tAgo',
              }"
              data-toggle="tab"
              href="?stats=tAgo"
              role="tab"
              @click.prevent="setRange('tAgo')"
            >
              {{ $t("common.days", { count: 30 }) }}
            </a>
          </li>
          <li class="nav-item m-tabs__item">
            <a
              :class="{
                'cursor-pointer nav-link m-tabs__link': true,
                active: selectedRange === 'nAgo',
              }"
              data-toggle="tab"
              href="?stats=nAgo"
              role="tab"
              @click.prevent="setRange('nAgo')"
            >
              {{ $t("common.days", { count: 90 }) }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div
      class="m-portlet__body m-portlet__body--no-padding py-0 overflow-hidden"
    >
      <div
        v-if="stats !== null"
        class="tab-content"
      >
        <div class="tab-pane active">
          <div class="row m-row--no-padding m-row--col-separator-xxl">
            <div
              class="col-12 col-md-12 col-lg-12 col-xl-6 col-xxl"
              data-stats="totalViews"
            >
              <div class="m-widget24 pt-3">
                <div class="m-widget24__item">
                  <h5 class="m-portlet__head-text-stats">
                    {{ $t("homepage.stats.TotalViews") }}
                    <span class="m-widget24__stats m--font-brand">
                      {{ $utils.formatCurrency(stats.views) }}
                    </span>
                  </h5>
                  <div class="separata mb-2" />
                  <span class="m-widget24__desc">
                    <router-link
                      :to="{
                        name: 'PropertiesAnalytics',
                        query: { fromdate: getFromDate(selectedRange), metric: 'views' }
                      }"
                      class="m-menu__link"
                    >
                      {{ $t("common.Properties") }}:
                      {{ $utils.formatCurrency(stats.properties.views) }}
                    </router-link>
                    <router-link
                      :to="{
                        name: 'DirectoriesAnalytics',
                        query: { fromdate: getFromDate(selectedRange), metric: 'view' }
                      }"
                      class="m-menu__link m-menu__link-right"
                    >
                      {{ $t("common.Business") }}:
                      {{ $utils.formatCurrency(stats.directories.views) }}
                    </router-link>
                  </span>
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-12 col-lg-12 col-xl-6 col-xxl"
              data-stats="detailedViews"
            >
              <div class="m-widget24 pt-3">
                <div class="m-widget24__item">
                  <h5 class="m-portlet__head-text-stats">
                    {{ $t("homepage.stats.DetailedViews") }}
                    <span class="m-widget24__stats m--font-brand">
                      {{ $utils.formatCurrency(stats.detailed) }}
                    </span>
                  </h5>
                  <div class="separata mb-2" />
                  <span class="m-widget24__desc">
                    <router-link
                      :to="{
                        name: 'PropertiesAnalytics',
                        query: { fromdate: getFromDate(selectedRange), metric: 'detailed' }
                      }"
                      class="m-menu__link"
                    >
                      {{ $t("common.Properties") }}:
                      {{ $utils.formatCurrency(stats.properties.detailed) }}
                    </router-link>
                    <router-link
                      :to="{
                        name: 'DirectoriesAnalytics',
                        query: { fromdate: getFromDate(selectedRange), metric: 'view' }
                      }"
                      class="m-menu__link m-menu__link-right"
                    >
                      {{ $t("common.Business") }}:
                      {{ $utils.formatCurrency(stats.directories.detailed) }}
                    </router-link>
                  </span>
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-12 col-lg-12 col-xl-6 col-xxl"
              data-stats="enquiries"
            >
              <div class="m-widget24 pt-3">
                <div class="m-widget24__item">
                  <h5 class="m-portlet__head-text-stats">
                    {{ $t("homepage.stats.Enquiries/Leads") }}
                    <span class="m-widget24__stats m--font-brand">
                      {{ $utils.formatCurrency(stats.enquiries) }}
                      <span>/</span>
                      {{ $utils.formatCurrency(stats.leads) }}
                    </span>
                  </h5>
                  <div class="separata mb-2" />
                  <span class="align-items-center d-flex justify-content-between m-widget24__desc">
                    <router-link
                      :to="{
                        name: 'PropertiesEnquiries',
                        query: { fromdate: getFromDate(selectedRange), type: 'web' }
                      }"
                      class="m-menu__link d-block"
                    >
                      {{ $t("common.Properties") }}:
                      {{ $utils.formatCurrency(stats.properties.enquiries) }}
                      / {{ $utils.formatCurrency(stats.properties.leads) }}
                      <span class="mt-2 d-block"><i
                        class="la la-whatsapp text-whatsapp mr-2"
                        style="font-size: 18px;"
                      />{{ $utils.formatCurrency(stats.properties.enquiriesWhatsApp) }} / {{ $utils.formatCurrency(stats.properties.leadsWhatsApp) }}</span>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'DirectoriesEnquiries',
                        query: { fromdate: getFromDate(selectedRange), type: 'web'}
                      }"
                      class="m-menu__link m-menu__link-right"
                    >
                      {{ $t("common.Business") }}:
                      {{ $utils.formatCurrency(stats.directories.enquiries) }}
                      /
                      {{ $utils.formatCurrency(stats.directories.leads) }}
                    </router-link>
                  </span>
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-12 col-lg-12 col-xl-6 col-xxl"
              data-stats="enquiries"
            >
              <div class="m-widget24 pt-3">
                <div class="m-widget24__item">
                  <h5 class="m-portlet__head-text-stats">
                    {{ $t("homepage.stats.Calls") }} /
                    {{ $t("homepage.stats.Callers") }}
                    <span class="m-widget24__stats m--font-brand">
                      {{ $utils.formatCurrency(stats.calls) }}
                      <span>/</span>
                      {{ $utils.formatCurrency(stats.callers) }}
                    </span>
                  </h5>
                  <div class="separata mb-2" />
                  <span class="m-widget24__desc">
                    <router-link
                      :to="{
                        name: 'PropertiesEnquiries',
                        query: { fromdate: getFromDate(selectedRange), type: 'phone' }
                      }"
                      class="m-menu__link"
                    >
                      {{ $t("common.Properties") }}:
                      {{ $utils.formatCurrency(stats.properties.calls) }} /
                      {{ $utils.formatCurrency(stats.properties.callers) }}
                    </router-link>
                    <router-link
                      :to="{
                        name: 'DirectoriesEnquiries',
                        query: { fromdate: getFromDate(selectedRange), type: 'phone' }
                      }"
                      class="m-menu__link m-menu__link-right"
                    >
                      {{ $t("common.Business") }}:
                      {{ $utils.formatCurrency(stats.directories.calls) }} /
                      {{ $utils.formatCurrency(stats.directories.callers) }}
                    </router-link>
                  </span>
                </div>
              </div>
            </div>

            <div
              :class="{ 'col-12': true, show: stats.commission > 0 }"
              data-stats="commision"
            >
              <div class="m-widget24 pt-3">
                <div class="m-widget24__item">
                  <h5 class="m-portlet__head-text-stats">
                    {{ $t("homepage.stats.Commision") }}
                    <span class="m-widget24__stats m--font-brand">
                      {{ $utils.formatCurrency(stats.commission) }}
                      <span>&euro;</span>
                    </span>
                  </h5>
                  <div class="separata mb-2" />
                  <span class="m-widget24__desc">
                    <small>{{
                      $t("homepage.stats.CommisionExplanation")
                    }}</small>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { clientapi } from '../../../api-clients/client-api.js';
import { businesslistingsapi } from '../../../api-clients/business-listings-api.js';
import { clientanalyticsapi } from '../../../api-clients/client-analytics-api.js';
import dayjs from 'dayjs';
import { getUser, getPropertyService } from '../../../functions.ts';

export default {
    name: 'Stats',
    data() {
        return {
            user: {},
            selectedRange: 'tAgo',
            tabActive: 'tAgo',
            stats: null,
            allStats: null,
            propertyService: null,
        };
    },
    watch: {
        '$route.query.stats': {
            handler: function( newStats, oldStats ) {
                let range = newStats || 'tAgo';
                this.selectedRange = range;
                this.loadStats( range );
            },
            immediate: false,
        },
    },
    async created() {
        this.user = getUser();
        let range = this.$route.query.stats || 'tAgo';
        this.propertyService = await getPropertyService();
        this.setRange( range );
        this.loadStats( range );
    },
    methods: {
        getDays( range ) {
            switch ( range ) {
            case 'sAgo':
                return 7;
            case 'tAgo':
                return 30;
            case 'nAgo':
                return 90;
            }

            return 30;
        },
        getFromDate( range ) {
            switch ( range ) {
            case 'sAgo':
                return dayjs().tz().subtract( 7, 'day' ).format( 'YYYY-MM-DD' );
            case 'tAgo':
                return dayjs().tz().subtract( 30, 'day' ).format( 'YYYY-MM-DD' );
            case 'nAgo':
                return dayjs().tz().subtract( 90, 'day' ).format( 'YYYY-MM-DD' );
            }

            return dayjs().tz().subtract( 30, 'day' ).format( 'YYYY-MM-DD' );
        },
        setRange( range ) {
            this.selectedRange = range;
            if ( this.$route.query.stats !== range ) {
                this.$router.push( { path: this.$route.path,
                    query: { stats: range } } );
            }
        },
        updateUrlQueryIfNecessary( range ) {
            if ( this.$route.query.stats !== range ) {
                this.$router.push( { path: this.$route.path,
                    query: { stats: range } } );
            }
        },
        async loadStats( range ) {
            mApp.block( '#portletStats', {
                centerX: true,
                centerY: true,
                message: this.$t( 'common.LoadingDataPleaseWait' ),
            } );

            let daysAgo = this.getDays( range );
            let from = dayjs().tz().subtract( daysAgo, 'days' );
            let to = dayjs().tz().subtract( 1, 'days' );

            if ( this.allStats && this.allStats[ range ] ) {
                this.stats = this.allStats[ range ];
                mApp.unblock( '#portletStats' );
                return;
            }

            let analyticsRequestForViews = {
                metric: 'views',
                interval: 'day',
                filter: {
                    PropertyFilter: {
                        Login: this.user.Login,
                    },
                    DateFilter: {
                        fromDate: from.format( 'YYYY-MM-DD' ),
                        toDate: to.format( 'YYYY-MM-DD' ),
                    },
                },
            };

            let totalPropertyViewsCall = clientanalyticsapi
                .post( '/property/metrics', analyticsRequestForViews )
                .then( ( response ) => {
                    if ( response.status !== 200 ) {
                        return 0;
                    }

                    var total = 0;
                    for ( let entry of response.data ) {
                        total += entry.Metric;
                    }

                    return total;
                } );

            let analyticsRequestForDetailed = {
                metric: 'detailed',
                interval: 'day',
                filter: {
                    PropertyFilter: {
                        Login: this.user.Login,
                    },
                    DateFilter: {
                        fromDate: from.format( 'YYYY-MM-DD' ),
                        toDate: to.format( 'YYYY-MM-DD' ),
                    },
                },
            };

            let totalPropertyDetailedViewsCall = clientanalyticsapi
                .post( '/property/metrics', analyticsRequestForDetailed )
                .then( ( response ) => {
                    if ( response.status !== 200 ) {
                        return 0;
                    }

                    var total = 0;
                    for ( let entry of response.data ) {
                        total += entry.Metric;
                    }

                    return total;
                } );

            let directoryViewsRequest = {
                Metric: 'view',
                Interval: 'day',
                From: from.format(),
                To: to.format(),
                Login: this.user.Login,
            };

            let totalDirectoryViewsCall = clientanalyticsapi
                .post( '/directory/metrics', directoryViewsRequest )
                .then( ( response ) => {
                    if ( response.status !== 200 ) {
                        return 0;
                    }
                    var total = 0;
                    for ( let entry of response.data ) {
                        total += entry.Value;
                    }

                    return total;
                } );

            let directoryDetailedRequest = {
                Metric: 'detailed',
                Interval: 'day',
                From: from.format(),
                To: to.format(),
                Login: this.user.Login,
            };

            let totalDirectoryDetailedViewsCall = clientanalyticsapi
                .post( '/directory/metrics', directoryDetailedRequest )
                .then( ( response ) => {
                    if ( response.status !== 200 ) {
                        return 0;
                    }

                    var total = 0;
                    for ( let entry of response.data ) {
                        total += entry.Value;
                    }

                    return total;
                } );

            let paramsEnquiryAndLeads = {
                FromDate: from.format(),
                ToDate: to.add( 1, 'days' ).format(),
                Spam: false,
            };

            let propertyEnquiriesCall = clientapi
                .get( '/propertyenquiries/stats', { params: paramsEnquiryAndLeads } )
                .then( ( res ) => {
                    if ( res.status !== 200 ) {
                        return {
                            propertyEnquiries: 0,
                            propertyLeads: 0,
                            propertyWhatsAppEnquiries: 0,
                            propertyWhatsAppLeads: 0,
                        };
                    }
                    return {
                        propertyEnquiries: res.data.count,
                        propertyLeads: res.data.distinctByEmail,
                        propertyWhatsAppEnquiries: res.data.countWhatsApp,
                        propertyWhatsAppLeads: res.data.distinctWhatsAppByEmail,
                    };
                } );

            let directoryParamsEnquiryAndLeads = {
                FromDate: from.format(),
                ToDate: to.add( 1, 'days' ).format(),
                Spam: false,
                Logins: this.user.Login,
            };

            let directoryEnquiriesCall = businesslistingsapi
                .get( '/listings/enquiries/stats', { params: directoryParamsEnquiryAndLeads } )
                .then( ( res ) => {
                    if ( res.status !== 200 ) {
                        return {
                            directoryEnquiries: 0,
                            directoryLeads: 0,
                        };
                    }
                    return {
                        directoryEnquiries: res.data.count,
                        directoryLeads: res.data.distinctByEmail,
                    };
                } );

            let iovoxSearchParams = new URLSearchParams();
            iovoxSearchParams.append( 'LinkName', 'form' );
            iovoxSearchParams.append( 'LinkName', 'confirmation' );
            iovoxSearchParams.append( 'FromDate', from.format() );
            iovoxSearchParams.append( 'Spam', 'false' );
            iovoxSearchParams.append( 'Deleted', 'false' );
            iovoxSearchParams.append( 'ToDate', to.add( 1, 'days' ).format() );

            let iovoxPropertyCall = clientapi
                .get( '/calls/stats', { params: iovoxSearchParams } )
                .then( ( res ) => {
                    if ( res.status !== 200 ) {
                        return {
                            propertyCalls: 0,
                            propertyCallers: 0,
                        };
                    }

                    return {
                        propertyCalls: res.data.count,
                        propertyCallers: res.data.distinctByCallOrigin,
                    };
                } );

            // copying those for property
            let iovoxDirectorySearchParams = new URLSearchParams(
                iovoxSearchParams.toString(),
            );
            iovoxDirectorySearchParams.set( 'LinkName', 'directory' );

            let iovoxDirectoryCall = clientapi
                .get( '/calls/stats', { params: iovoxDirectorySearchParams } )
                .then( ( res ) => {
                    if ( res.status !== 200 ) {
                        return {
                            directoryCalls: 0,
                            directoryCallers: 0,
                        };
                    }
                    return {
                        directoryCalls: res.data.count,
                        directoryCallers: res.data.distinctByCallOrigin,
                    };
                } );

            let perfParams = {
                FromDate: from.format(),
                ToDate: to.add( 1, 'days' ).format(),
            };

            // based on CCP-519 we calculate commission only for
            // logins with at least 5 properties
            let commission = 0;

            if ( this.propertyService.PropertyLimit >= 5 ) {
                commission = await clientapi
                    .get( '/performance', { params: perfParams } )
                    .then( ( res ) => {
                        if ( res.status !== 200 ) {
                            return 0;
                        }
                        return res.data.Commission;
                    } );
            }

            let totalPropertyViews = await totalPropertyViewsCall;
            let totalPropertyDetailedViews = await totalPropertyDetailedViewsCall;
            let totalDirectoryViews = await totalDirectoryViewsCall;
            let totalDirectoryDetailedViews = await totalDirectoryDetailedViewsCall;
            let { propertyEnquiries, propertyLeads, propertyWhatsAppEnquiries, propertyWhatsAppLeads } = await propertyEnquiriesCall;
            let { directoryEnquiries, directoryLeads } = await directoryEnquiriesCall;
            let { propertyCalls, propertyCallers } = await iovoxPropertyCall;
            let { directoryCalls, directoryCallers } = await iovoxDirectoryCall;

            let stats = {
                from: from,
                to: to,
                views: totalPropertyViews + totalDirectoryViews,
                detailed: totalPropertyDetailedViews + totalDirectoryDetailedViews,
                enquiries: propertyEnquiries + directoryEnquiries,
                leads: propertyLeads + directoryLeads,
                calls: propertyCalls + directoryCalls,
                callers: propertyCallers + directoryCallers,
                commission: commission,
                properties: {
                    views: totalPropertyViews,
                    detailed: totalPropertyDetailedViews,
                    enquiries: propertyEnquiries,
                    enquiriesWhatsApp: propertyWhatsAppEnquiries,
                    leads: propertyLeads,
                    leadsWhatsApp: propertyWhatsAppLeads,
                    calls: propertyCalls,
                    callers: propertyCallers,
                },
                directories: {
                    views: totalDirectoryViews,
                    detailed: totalDirectoryDetailedViews,
                    enquiries: directoryEnquiries,
                    leads: directoryLeads,
                    calls: directoryCalls,
                    callers: directoryCallers,
                },
            };

            this.stats = stats;

            this.allStats = this.allStats || {};

            this.allStats[ range ] = this.stats;

            mApp.unblock( '#portletStats' );
        },
    },
};
</script>
